export enum RepetitionFrequency {
    Once = 'Once',
    Daily = 'Daily',
    Weekly = 'Weekly',
    MonthlyOnDate = 'MonthlyOnDate',
    MonthlyOnDayOfWeek = 'MonthlyOnDayOfWeek',
    Yearly = 'Yearly',
    Custom = 'Custom'
};

export enum DaysOfTheWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday"
}

export enum RepetitionEndType {
    Never = 'Never',
    EndDate = 'EndDate',
    AfterOccurrences = 'AfterOccurrences'
}

type RepetitionEndTypeNever = { endType: RepetitionEndType.Never };
type RepetitionEndTypeEndDate = { endType: RepetitionEndType.EndDate, endDate: Date };
type RepetitionEndTypeAfterOccurrences = { endType: RepetitionEndType.AfterOccurrences, numOccurrences: number };

export type IRepetitionEnding = RepetitionEndTypeNever | RepetitionEndTypeEndDate | RepetitionEndTypeAfterOccurrences;

export interface IRepetitionPattern {
    startTimestamp: Date;
    endTimestamp: Date;
    timeZone: string;
    frequency: RepetitionFrequency;
    interval: number;
    // customFrequencyDescriptor: SingularFrequencies | PluralFrequencies;
    daysOfTheWeek: DaysOfTheWeek[];
    // monthlyRepetitionPattern: MonthlyRepetitionType;
    ending: IRepetitionEnding;
}


// timeZone: string;
// frequency: string;
// interval: number;
// daysOfTheWeek: string[];
// endType: string;
// repetitionEndDaysFromStart?: number;
// occurrences?: number;